import React from "react";
import Grid from "@mui/material/Grid";
import { Box, Button, Typography } from "@mui/material"
import style from "./style";
import color from "../../../../../constants/color"
import SubHeader from "../../../../../components/SubHeader"
import SalesReportList from "./SalesReportList";
import { ReactComponent as Cart } from "../../../../../assets/invoice/fluent_cart-24-regular.svg";
import { ReactComponent as Trophy } from "../../../../../assets/invoice/tabler_trophy.svg";
import { ReactComponent as Group } from "../../../../../assets/invoice/Group 160.svg";
import { ReactComponent as Growth } from "../../../../../assets/invoice/carbon_growth.svg";
import { BarChart } from "@mui/x-charts/BarChart";
import { useTheme, useMediaQuery } from "@mui/material";
import theme from "../../../../../theme/theme";
import { useNavigate } from "react-router-dom";

const yearly = [70, 50, 60, 65, 55, 65, 80,70, 80, 70, 80, 70];
// const hired = [30, 20, 5, 25, 40, 30, 5];
// const resigned = [0, 10, 20, 30, 40, 50, 15, 20, 20, 20, 20, 20];
const xLabels = ["Jan ", "Feb", "March", "April", "May", "June", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];





// import dayjs from "dayjs";



const SalesReport = (data, total,page,setPage,handleDelete,handleFilter) => {
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate("/dashboard/salesList")
  }
  const handleNavigates = () => {
    navigate("/dashboard/newSalesOrders")
  }


  const materialUITheme = useTheme();
  const isDesktop = useMediaQuery(materialUITheme.breakpoints.up("md"));
  const isLargeMobile = useMediaQuery("(max-width: 768px)");
  const isSmallMobile = useMediaQuery("(max-width: 400px)");
  
  //   const handleAccountData = async (data) => {
  //     handleAccountSetting(data);
  //   }
  //   const handleLeaveType = async (leave) => {
  //     handleAccountLeaveType(leave);
  //   }

  //   const { state, handleChange, handleSubmit, handleFocus, } = useForm(
  //     accountSettingData,
  //     AccountSettingsValidate,
  //     handleAccountData,
  //   );
  //   const { companyName, email, phone, addressLine1, addressLine2, city, states, zipCode, country, companyRegistrationNumber, number, currency } = state;

  return (
    <>


      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Sales Report</Typography>
          <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
            <Button variant="contained" color="success" sx={style.checkinBtn} onClick={handleNavigate}>View Sales
            </Button>
            <Button variant="contained" color="success" sx={style.checkoutBtn} onClick={handleNavigates}> + Add Sales
            </Button>
          </Box>
        </Box>


      </Box>
      <form>

        <Grid container spacing={2} px="15px">
          <Grid item md={3} xs={12}>
            <Box sx={style.cardGrid}>
              <Box sx={style.iconSection}>
                <Cart/>
              </Box>
              <Box>
                <Typography sx={style.textHeading}>Number Of Sales</Typography> 
                <Typography sx={style.textNumber}>20356</Typography>
                <Typography sx={style.textMonth}>1.23% (Since last month)</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={3} xs={12}>
            <Box sx={style.cardGrid}>
              <Box sx={style.iconSection}>
                <Trophy/>
              </Box>
              <Box>
                <Typography sx={style.textHeading}>Total Orders</Typography> 
                <Typography sx={style.textNumber}>19300</Typography>
                <Typography sx={style.textMonth}>6.23% (Since last month)</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={3} xs={12}>
            <Box sx={style.cardGrid}>
              <Box sx={style.iconSection}>
                <Group/>
              </Box>
              <Box>
                <Typography sx={style.textHeading}>New User</Typography> 
                <Typography sx={style.textNumber}>1256</Typography>
                <Typography sx={style.textMonth}>1.23% (Since last month)</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={3} xs={12}>
            <Box sx={style.cardGrid}>
              <Box sx={style.iconSection}>
                <Growth/>
              </Box>
              <Box>
                <Typography sx={style.textHeading}>Total Earning</Typography> 
                <Typography sx={style.textNumber}>$20356</Typography>
                <Typography sx={style.textMonth}>5.55% (Since last month)</Typography>
              </Box>
            </Box>
          </Grid>



        </Grid>
 

        <Grid container spacing={2} px="15px">
          <Grid item md={12} xs={12}>
            <Box sx={style.cardGrid}>
              <Box sx={style.cardGraph}>
                <Typography sx={style.salesText}>Sales Analytics</Typography>
                <BarChart
                  width={isDesktop ? 1000 : (isLargeMobile ? 950 : (isSmallMobile ? 250 : "100%"))}
                  height={isDesktop ? 400 : (isLargeMobile ? 550 : (isSmallMobile ? 200 : 150))}
                  p={0}
                  series={[
                    { data: yearly, label: "yearly", id: "pvId", stack: "total", color: theme.palette.primary.main },
                    // { data: hired, label: "Hired", id: "hiId", stack: "total", color: theme.palette.lightGray.main },
                    // { data: resigned, label: "Resigned", id: "uvId", stack: "total", color: theme.palette.secondary.main },
                  ]}
                  sx={{
                    "& .css-1b57f9y-MuiChartsAxis-root .MuiChartsAxis-tick ": {
                      stroke: "#fff",
                    },
                    "& .MuiChartsAxis-line": {
                      display: "none",
                    },
                  }}
                  xAxis={[{ data: xLabels, scaleType: "band", categoryGapRatio: 0.4 }]}
                />

              </Box>
            </Box>
          </Grid></Grid>


        


      </form>
      <Box sx={{ backgroundColor: color.card, m: 2, borderRadius: "20px" }}>
        <SubHeader
          search={true}
          sortBy={true}
          onchange={(txt) => handleFilter(txt)}
          handleSort={(txt) => handleFilter("",txt)}
        />
        <SalesReportList data={data} page={page}setPage={setPage} total={total} handleDelete={handleDelete}/>
    

      </Box>

    </>
  )

}
export default SalesReport;
